import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const BASE_URL = typeof window !== 'undefined' ? window.location.origin : '';

const upsertMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    const isLink = selector.startsWith('link');
    el = document.createElement(isLink ? 'link' : 'meta');
    if (isLink) {
      el.setAttribute('rel', 'alternate');
    } else {
      const m = selector.match(/\[(name|property)="([^"]+)"\]/);
      if (m) el.setAttribute(m[1], m[2]);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const clearAlternates = () => {
  document.head
    .querySelectorAll('link[rel="alternate"][data-i18n="true"]')
    .forEach((n) => n.remove());
};

const addAlternate = (hrefLang, path) => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'alternate');
  link.setAttribute('hreflang', hrefLang);
  link.setAttribute('href', `${BASE_URL}${path}`);
  link.setAttribute('data-i18n', 'true');
  document.head.appendChild(link);
};

export const LangMeta = ({ lang }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
  }, [lang, i18n]);

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t('meta.title');
    upsertMeta('meta[name="description"]', 'content', t('meta.description'));
    upsertMeta('meta[property="og:title"]', 'content', t('meta.title'));
    upsertMeta('meta[property="og:description"]', 'content', t('meta.description'));
    upsertMeta('meta[property="og:locale"]', 'content', lang === 'sv' ? 'sv_SE' : 'en_US');

    clearAlternates();
    addAlternate('en', '/en');
    addAlternate('sv', '/sv');
    addAlternate('x-default', '/en');
  }, [lang, t]);

  return null;
};
